import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { required } from '../../Helpers/validators';
import CurrencyHelper from '../../Helpers/CurrencyHelper';
import CoverageField from './CoverageField';
import { Button } from '@jauntin/react-ui';

const Edit = ({
  confirm,
  show,
  fieldOptions,
  enabled,
  aboutEventRef,
  scrollToPosition,
  ACSellingLiquor,
}) =>
  show && (
    <>
      <div className="form-row">
        <Field
          disabled={!enabled}
          component={CoverageField}
          validate={[required]}
          name="generalLiabilityCoverage"
          fieldOptions={fieldOptions}
        />
      </div>
      {!ACSellingLiquor && (
        <div className="form-row d-flex">
          <div className="col-auto">
            <i className="fas fa-check" />
          </div>
          <div className="d-flex flex-column col">
            <h6>Includes Host Liquor</h6>
            <p className="text-dark font-italic font-weight-normal">
              Provides coverage when your venue serves alcoholic beverages or
              allows alcoholic beverages to be consumed on the premises.
            </p>
          </div>
        </div>
      )}
      <hr />
      <div className="d-flex justify-content-between">
        <h5>Damage to Rented Premises</h5>
        <div className="my-auto">
          <span className="font-weight-bold">Limit</span>{' '}
          {new CurrencyHelper().setValue(250000).dollars()}
        </div>
      </div>
      <div className="text-dark font-italic font-weight-normal mw--455">
        Basic protection for damage that you or your guests may cause to the
        event space.
      </div>
      <hr />
      <div className="form-row d-flex">
        <div className="col form-group my-auto">
          <a
            href={`${process.env.REACT_APP_COVERAGE_DETAILS_LINK}`}
            rel="noopener noreferrer"
            target="_blank"
            className="span-link"
            tabIndex={!enabled ? '-1' : '0'}
          >
            Coverage Details
          </a>
        </div>
        <div className="col text-right">
          <Button
            disabled={!enabled}
            onClick={() => {
              confirm();
              scrollToPosition(aboutEventRef);
            }}
            text="Next"
            className="btn-primary"
          />
        </div>
      </div>
    </>
  );

Edit.propTypes = {
  confirm: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  enabled: PropTypes.bool.isRequired,
  fieldOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  scrollToPosition: PropTypes.func.isRequired,
  aboutEventRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  ACSellingLiquor: PropTypes.bool.isRequired,
};

export default Edit;
